export default __webpack_public_path__ + "static/media/dark.3ac635f8.png";